import axiosInstance from '../../axios/axiosInstance'

export interface ScorecardData {
  name: string
  /** Full-size card images, in order. */
  cards: string[]
  /** The 50% offer, while it is still open for this learner. */
  offer: { endsOn: string } | null
}

/** The learner's Scorecard for a signed link. Null when the link is not valid, so the page can say so. */
export const getScorecard = async (token: string): Promise<ScorecardData | null> => {
  try {
    const res = await axiosInstance.get('scorecard/data', { params: { t: token } })
    return res?.data?.cards?.length ? (res.data as ScorecardData) : null
  } catch (error) {
    return null
  }
}
